import { useEffect, useState } from "react";

// Energi ⚡ lokal: dari snapshot dompet (energi, energi_berikut_detik, energi_regen_detik), hitung mundur per detik
// dan tambah +1 tiap periode regen tanpa menunggu server. Snapshot baru (muat ulang dompet) me-reset hitungan.
export function useEnergi(dompet) {
  const [e, setE] = useState({ energi: null, berikut: 0 });
  useEffect(() => {
    if (!dompet) return;
    let energi = dompet.energi, berikut = dompet.energi_berikut_detik, regen = dompet.energi_regen_detik || 180;
    setE({ energi, berikut });
    const t = setInterval(() => {
      if (energi >= dompet.energi_maks) { berikut = 0; }
      else if (berikut <= 1) { energi = Math.min(dompet.energi_maks, energi + 1); berikut = energi >= dompet.energi_maks ? 0 : regen; }
      else berikut -= 1;
      setE({ energi, berikut });
    }, 1000);
    return () => clearInterval(t);
  }, [dompet]);
  return e;
}
